const DISPLAY_PLUS_IF_GREATER_THAN = 9;

export const useChatMessagesAmountBadge = (
    unreadMessagesAmount: Ref<number>
) => {
    const isGreaterThanDisplayPlusLimit = computed(() => {
        return unreadMessagesAmount.value > DISPLAY_PLUS_IF_GREATER_THAN;
    });

    const amountToDisplay = computed(() =>
        isGreaterThanDisplayPlusLimit.value
            ? `${DISPLAY_PLUS_IF_GREATER_THAN}+`
            : unreadMessagesAmount.value
    );

    const messagesBadgeStyles = computed(() => ({
        'text-[10px]': !isGreaterThanDisplayPlusLimit.value,
        'text-[8px]': isGreaterThanDisplayPlusLimit.value,
    }));

    return {
        isGreaterThanDisplayPlusLimit,
        messagesBadgeStyles,
        amountToDisplay,
    };
};
